package link.erpango.quip.data.remote

class ApiUrlResolver(
    private val url: String
): IApiUrlResolver {

    override val baseUrl get() = url
}

interface IApiUrlResolver {

    val baseUrl: String
}